const Scrap = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      data-testid="usage-card-image-scrap"
    >
      <path
        d="M29.6639 12H18.1494C15.8568 12 14 13.8289 14 16.0868V33.1699C14 35.3972 16.5104 36.7458 18.4191 35.5504L24 32.0971L29.5809 35.5504C31.5 36.7458 34 35.3768 34 33.1392V16.0868C34 13.8289 32.1432 12 29.8506 12H29.6639Z"
        fill="#8646F2"
      />
    </svg>
  );
};

const Mail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      data-testid="usage-card-image-mail"
    >
      <path
        d="M37.883 18.5872C34.823 18.5872 32.3392 16.1232 32.3392 13.0898H12.0244C9.24775 13.0898 7 15.3579 7 18.1672V32.9233C7 35.7233 9.24775 38.0007 12.0244 38.0007H34.6341C37.4108 38.0007 39.6585 35.7327 39.6585 32.9233V18.2979C39.1013 18.4845 38.5063 18.5872 37.883 18.5872Z"
        fill="#FFC9C9"
      />
      <path
        d="M37.8862 16.1787C39.6074 16.1787 41.0028 14.7956 41.0028 13.0894C41.0028 11.3831 39.6074 10 37.8862 10C36.1649 10 34.7695 11.3831 34.7695 13.0894C34.7695 14.7956 36.1649 16.1787 37.8862 16.1787Z"
        fill="#EB3F3F"
      />
      <path
        d="M32.3414 13.0898H23.3315H12.0267C10.2133 13.0898 8.64558 14.0699 7.75781 15.5165L21.8582 25.6059C22.7365 26.2313 23.9171 26.2313 24.7954 25.6059L35.4203 18.0085C33.5975 17.1125 32.3414 15.2459 32.3414 13.0898Z"
        fill="#EB3F3F"
      />
    </svg>
  );
};

const Slackbot = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      data-testid="usage-card-image-slackbot"
    >
      <path
        d="M26.9717 10.8C26.9717 9.248 25.6425 8 24.0015 8C22.3605 8 21.0312 9.248 21.0312 10.8C21.0312 12.08 21.9666 13.12 23.2138 13.456V15.888H24.7728V13.456C26.02 13.12 26.9553 12.096 26.9553 10.8H26.9717Z"
        fill="#BB98F7"
      />
      <path
        d="M23.5733 15.0078C14.7774 15.2318 8 22.5118 8 30.8158C8 32.9918 9.87076 34.7517 12.1682 34.7517H35.0768C37.7845 34.7517 39.9999 32.6718 39.9999 30.1118C39.9999 21.6478 32.5989 14.7998 23.5733 15.0238V15.0078ZM19.4707 27.4398C18.5025 27.4398 17.6984 26.6878 17.6984 25.7758C17.6984 24.8638 18.4861 24.1118 19.4707 24.1118C20.4553 24.1118 21.243 24.8638 21.243 25.7758C21.243 26.6878 20.4553 27.4398 19.4707 27.4398ZM28.5292 27.4398C27.561 27.4398 26.7569 26.6878 26.7569 25.7758C26.7569 24.8638 27.5446 24.1118 28.5292 24.1118C29.5138 24.1118 30.3015 24.8638 30.3015 25.7758C30.3015 26.6878 29.5138 27.4398 28.5292 27.4398Z"
        fill="#8646F2"
      />
      <rect
        x="10.8711"
        y="36.8008"
        width="26.2563"
        height="3.19999"
        rx="1.59999"
        fill="#BB98F7"
      />
    </svg>
  );
};

const Bulb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      data-testid="usage-card-image-bulb"
    >
      <path
        d="M36.98 20.26C36.98 12.94 31.1645 7 23.99 7C16.8155 7 11 12.94 11 20.26C11 23.26 11.9892 26.02 13.638 28.24H13.628L17.3551 33.52H30.6449L34.372 28.25H34.362C36.0108 26.02 37 23.26 37 20.27L36.98 20.26Z"
        fill="#FFC9C9"
      />
      <path
        d="M30.6335 33.5098H17.3438V37.7698C17.3438 39.5498 18.7627 40.9998 20.5013 40.9998H27.466C29.2146 40.9998 30.6235 39.5598 30.6235 37.7698V33.5098H30.6335Z"
        fill="#EB3F3F"
      />
      <path
        d="M29.6153 18.3508C29.5054 18.1108 29.2556 17.9708 29.0158 17.9708H25.7283V14.1608C25.7283 13.8608 25.5385 13.6208 25.2587 13.5108C24.9889 13.4308 24.6791 13.5108 24.4893 13.7308L18.4539 21.4308C18.294 21.6508 18.2641 21.9208 18.374 22.1408C18.4839 22.3608 18.7337 22.5208 18.9735 22.5208H22.241V26.3508C22.241 26.6508 22.4309 26.8908 22.7106 27.0008C22.7906 27.0008 22.8505 27.0308 22.9305 27.0308C23.1503 27.0308 23.3402 26.9508 23.4801 26.7608L29.5454 19.0608C29.7053 18.8408 29.7352 18.5708 29.6253 18.3508H29.6153Z"
        fill="#EB3F3F"
      />
    </svg>
  );
};

export { Scrap, Mail, Slackbot, Bulb };
